export type EcoMicInputMode = 'tap' | 'mic' | 'both';

export interface EcoMicSettings {
  inputMode: EcoMicInputMode;
  /** 0 = menos sensible, 100 = más sensible. */
  sensitivity: number;
}

const STORAGE_KEY = 'eco-ritmo-mic-settings';

export const DEFAULT_ECO_MIC_SETTINGS: EcoMicSettings = {
  inputMode: 'both',
  sensitivity: 55,
};

export function loadEcoMicSettings(): EcoMicSettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_ECO_MIC_SETTINGS };
    const parsed = JSON.parse(raw) as Partial<EcoMicSettings>;
    const inputMode =
      parsed.inputMode === 'tap' || parsed.inputMode === 'mic' || parsed.inputMode === 'both'
        ? parsed.inputMode
        : DEFAULT_ECO_MIC_SETTINGS.inputMode;
    const sensitivity =
      typeof parsed.sensitivity === 'number'
        ? Math.min(100, Math.max(0, Math.round(parsed.sensitivity)))
        : DEFAULT_ECO_MIC_SETTINGS.sensitivity;
    return { inputMode, sensitivity };
  } catch {
    return { ...DEFAULT_ECO_MIC_SETTINGS };
  }
}

export function saveEcoMicSettings(settings: EcoMicSettings): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch {
    /* ignore */
  }
}

export function micInputLabel(mode: EcoMicInputMode): string {
  switch (mode) {
    case 'tap':
      return 'Pantalla';
    case 'mic':
      return 'Micrófono';
    case 'both':
      return 'Pantalla + mic';
  }
}
